import { PlusOutlined } from '@ant-design/icons'
import type { ReactNode } from 'react'
import { useBrowsePopover } from './BrowsePopoverContext'
import { BrowseHoverPopover } from './BrowseHoverPopover'
import './BrowseField.css'

type Props = {
  placeholder?: string
  hidePlaceholder?: boolean
  children?: ReactNode
  panel: ReactNode
  panelClassName?: string
  disabled?: boolean
  className?: string
  trigger?: 'hover' | 'click'
  /** 表单内占满一行，浏览按钮固定右侧不换行 */
  block?: boolean
  /** input：带边框输入框样式，右侧常驻浏览图标 */
  variant?: 'inline' | 'input'
}

function BrowseFieldBody({
  placeholder = '未选择',
  hidePlaceholder = false,
  children,
  disabled,
  className,
  block = false,
  variant = 'inline',
}: Omit<Props, 'panel' | 'panelClassName' | 'trigger'>) {
  const popover = useBrowsePopover()
  const empty = children == null || (Array.isArray(children) && children.length === 0)
  const showPlaceholder = !empty ? false : variant === 'input' ? true : !hidePlaceholder

  return (
    <div
      className={[
        'app-browse-field',
        block ? 'app-browse-field--block' : '',
        variant === 'input' ? 'app-browse-field--input' : '',
        popover?.open ? 'app-browse-field--open' : '',
        disabled ? 'app-browse-field--disabled' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {showPlaceholder ? (
        <div className="app-browse-field-display app-browse-field-display--empty">{placeholder}</div>
      ) : !empty ? (
        <div className="app-browse-field-display">{children}</div>
      ) : null}
      <span className="app-browse-field-trigger" aria-hidden>
        <PlusOutlined />
      </span>
    </div>
  )
}

export function BrowseField({
  placeholder = '未选择',
  hidePlaceholder = false,
  children,
  panel,
  panelClassName,
  disabled,
  className,
  trigger = 'hover',
  block = false,
  variant = 'inline',
}: Props) {
  return (
    <BrowseHoverPopover
      panel={panel}
      panelClassName={panelClassName}
      disabled={disabled}
      trigger={trigger}
      block={block}
    >
      <BrowseFieldBody
        placeholder={placeholder}
        hidePlaceholder={hidePlaceholder}
        disabled={disabled}
        className={className}
        block={block}
        variant={variant}
      >
        {children}
      </BrowseFieldBody>
    </BrowseHoverPopover>
  )
}
